<script lang="ts">
  import CollapseSection from '$lib/components/common/CollapseSection.svelte';
  import DataIcon from '$lib/icons/DataIcon.svelte';

  $: hasWorkflow = () => {
    // NOTE! THIS IS JUST A WORKAROUND. WE SHOULD NOT INSERT WORKFLOW TO DB UNLESS USER CHANGES IT.
    if (
      workflow &&
      workflow.length === 1 &&
      workflow[0].title === '' &&
      workflow[0].paragraphs.length === 1 &&
      workflow[0].paragraphs[0].value === ''
    ) {
      return false;
    }

    if (!workflow) return false;

    return true;
  };

  export let workflow: any;
  export let userName: string;
</script>

<div class="flex flex-col gap-6">
  {#if hasWorkflow()}
    {#each workflow as step, i}
      <CollapseSection contentOpen>
        <div slot="title" class="font-medium text-blueish-grey-900">
          {`${i + 1}. ${step.title}`}
        </div>
        <div
          class="border-t border-grey-transparency-dark border-opacity-5 pt-4 mt-4 flex flex-col gap-8"
        >
          {#each step.paragraphs as paragraph}
            <div class="flex flex-col gap-2">
              <span class="text-blueish-grey-600 text-sm font-medium break-words"
                >{paragraph.label}</span
              >
              <span class="text-garden-grey-800 break-words">{paragraph.value}</span>
            </div>
          {/each}
        </div>
      </CollapseSection>
    {/each}
  {:else}
    <div class="grid place-items-center">
      <div
        class="flex flex-col max-w-screen-sm text-center text-blueish-grey-700 p-4 items-center justify-center"
      >
        <span class="p-4 text-blueish-grey-700 bg-blueish-grey-100 rounded-full font-normal">
          <DataIcon size={54} fill="currentColor" />
        </span>
        <h3 class="font-switzer text-2xl">Workflow not updated</h3>
        <span class="font-normal text-blueish-grey-500">
          @{userName} has not updated the workflow <br />of this performance yet, please check back
          later.
        </span>
      </div>
    </div>
  {/if}
</div>
